export const API = process.env.VUE_APP_API;
export const KEY = process.env.VUE_APP_ENCKEY;
export const APP_DIRECTORY = process.env.VUE_APP_VIRTUAL_DIRECTORY;
export const SQUARE_LOCATION_ID = process.env.VUE_APP_SQUARE_LOCATION_ID;
export const SQUARE_APPLICATION_ID = process.env.VUE_APP_SQUARE_APPLICATION_ID;